<template>
  <div>
    <List v-for="list in lists" :key="list.title" :list="list" class="mb-3 mb-md-4" />
  </div>
</template>

<script>
import List from "./EssentialsList";

export default {
  name: "EssentialsLists",
  components: {
    List,
  },
  props: {
    lists: {
      type: Array,
      required: true,
    },
  },
};
</script>
